import { DefaultValueDefinition, DefaultValueFunction } from 'app/infrastructure/ui/types-uischema';
import { codeItemToStoreValue } from 'app/infrastructure/data/codes';
import { api } from 'app/area/shared/api';
import { StoreField } from 'app/types-shared';
import { error } from 'app/infrastructure/log';
import { CodetableWireFormat } from 'app/infrastructure/ui/form/types-codetable';
import { parseDate } from '../../infrastructure/data/date';

export type DefaultValueHandlerSettings = {utcOffset?: number};
export type DefaultValueHandler = (request: DefaultValueDefinition, settings?: DefaultValueHandlerSettings) => any;

const defaultValueHandlers: {[key:string]: DefaultValueHandler} = {

  [DefaultValueFunction.codeValue]: (request: DefaultValueDefinition) => {
    return request.value && codeItemToStoreValue(request.value as CodetableWireFormat);
  },

  [DefaultValueFunction.dateValue]: async (request: DefaultValueDefinition, settings: DefaultValueHandlerSettings = {}) => {
    let date = undefined;

    if (request.dateRegex) {
      date = parseDate(request.dateRegex);
    }
    
    if (!date && request.dbFunction) {      
      date = await api.date(request.dbFunction, settings.utcOffset);
    }

    return date && { value: date } as StoreField;
  }

};

const fallbackHandler = (request: DefaultValueDefinition) => undefined;

export const defaultValueHandler = (request: DefaultValueDefinition, settings: DefaultValueHandlerSettings) => {
  try {
    return defaultValueHandlers[request.valueFunction](request, settings) || fallbackHandler(request);
  } catch(err) {
    error('Error in defaultValueHandler', err);
    return undefined;
  }
};
